import { ICountryEntity } from '../../model/api/location/country.entity.interface';
import { IStateProvinceEntity } from '../../model/api/location/state-province.interface';
import { IAgentToGeoLocationEntity } from '../../model/api/location/geolocation.entity.interface';
import { ICoreAgentAddress } from '../../model/models/location/core-location.address.interface';
import { ICountry } from '../../model/models/location/country.interface';
import { IStateProvince } from '../../model/models/location/state-province.interface';
import { ILocation } from '../../model/models/location/location.interface';
import { ICoreLocation } from '../../model/models/location/core-location.interface';
import { ICoreAgentAddressEntity } from '../../model/api/location/core-location.address.entity.interface';
//import { ICoreLocationEntity } from '../../model/api/location/core-location.entity.interface';

export class LocationMapper {

  public static fromCountriesEntity(entities: ICountryEntity[]): ICountry[] {
    const countries: ICountry[] = [];
    entities.forEach((entity) => countries.push({
      isoCode: entity.abbrev.toUpperCase(),
      countryName: entity.countryName,
      isOpenPaymentCountry: entity.isOpenPaymentCountry,
      openPaymentDefaultAgentId: entity.openPaymentDefaultAgentId,
      openPaymentDefaultAgentLocationId: entity.openPaymentDefaultAgentLocationId,
    }));

    return countries;
  }

  public static fromStateProvicesEntity(entities: IStateProvinceEntity[]): IStateProvince[] {
    const states: IStateProvince[] = [];

    entities.forEach((entity) => states.push({
      id: entity.stateId,
      name: entity.state,
      abbreviation: entity.stateAbbreviation,
      note: entity.note,
    }));

    return states;
  }

  public static fromAgentToGeoLocationEntity(entities: IAgentToGeoLocationEntity[]): ILocation[] {
    return entities.map((entity) => ({
      businessHoursText : entity.businessHoursText,
      longitude: entity.longitude,
      latitude: entity.latitude,
      distanceFromOriginMiles: entity.distanceFromOriginMiles,
      distanceFromOriginKilometers: entity.distanceFromOriginKilometers,
      confidence: entity.confidence,
      geolocationConfidenceLevel: entity.geolocationConfidenceLevel,
      addressValidatedConfidence: entity.addressValidatedConfidence,
      addressValidatedUserId: entity.addressValidatedUserId,
      agentToId: entity.agentToId,
      agentToName: entity.agentToName,
      locationId: entity.locationId,
      name: entity.name,
      address: entity.address,
      address2: entity.address2,
      city: entity.city,
      state: entity.state,
      currency:entity.currency,
      phone: entity.phone,
      locationType: entity.locationType,
      collectionLocation: entity.collectionLocation,
      payoutLocation: entity.payoutLocation,
      sendLocation: entity.sendLocation,
      businessHours: entity.businessHours,
    }));
  }

  public static fromCoreAgentLocationEntity(entities): ICoreLocation[] {
    return entities.map((entity) => ({
      agentId: entity.agentId,
      agentLocId: entity.agentLocId,
      agentNo: entity.agentNo,
      name: entity.name,
      agentLocName: entity.agentLocName,
      distance: entity.distance,
      sendLocation: entity.sendLocation,
      payoutLocation: entity.payoutLocation,
      collectLocation: entity.collectLocation,
      currencyExchangeLocation: entity.currencyExchangeLocation,
      ownedByCompany: entity.ownedByCompany,
      brandIconKey: entity.brandIconKey,
      agentTelephone: entity.agentTelephone,
      locationDisplayName: entity.locationDisplayName,
      agentName: entity.agentName,
      acceptCash: entity.acceptCash,
      address: this.fromCoreAgentAddressEntity(entity.address),
      eWalletLocation:entity.eWalletLocation
    }));
  }

  public static fromCoreAgentAddressEntity(entity: ICoreAgentAddressEntity): ICoreAgentAddress {
    const address = {
      street: entity.street,
      postalCode: entity.postalCode,
      city: entity.city,
      country: entity.country,
      latitude: entity.latitude,
      longitude: entity.longitude
    }
    return address;
  }
}


// WEBPACK FOOTER //
// ./src/providers/location/location.mapper.ts